// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

export const environment = {
  production: true,
  appName: 'SEC Transcripcion',
  externalTitle: 'Meeting Transcription',
  disclosureAuthor: 'SEC',
  urlServerApi: 'https://apim-p-idb-integration.iadb.org/api/operations/sec/stt/',
  urlAudioApi: 'https://secwebapps.iadb.org/SecServices/api/meetings/recordings/audio/',
  scopeServerApi: 'api://1d6213a8-0aca-4608-bd1e-1d53e8eef247/Execute',
  scopeAudioApi: 'api://b035d43f-bf0c-4c45-a0b6-e311e4a686fb/access_as_user',
  urlAgendaApi: 'https://secwebapps.iadb.org/SecServices/api/agenda/',
  urlStarics: {
    contact: 'contactus.html',
    help: 'help.html',
    policy: 'https://www.iadb.org/',
    privacyPolicy: 'privacy-policy',
    terms: 'termsandconditions.html'
  },
  urgentNotice: false,
  off: false,
  useHash: false,
  MaxSessionWindowsTimeInSeconds: 600,
  filterAccess: false,
  allowedsUsers: ['cristhian.chavez.c', 'angie.roqhdz'],
  openId: {
    clientID: 'c634b25d-b6ff-4295-9c95-1579bf6dac96',
    authority: 'https://login.microsoftonline.com/9dfb1a05-5f1d-449a-8960-62abcb479e7d',
    redirectUri: 'https://speechtotext.iadb.org/',
    logoutRedirectUri: 'https://www.iadb.org/',
  },
  headerSubscriptionKey: 'Ocp-Apim-Subscription-Key',
  subscriptionKey: '841b82e48ba0412e9dbcf8d77fb99071'
};

